import RailsResource from './rails-resource';

class CalendarProfessorService extends RailsResource {
  constructor() {
    super({
      url: '/admin/professor',
      resource: 'calendar',
      ajaxLoader: false
    });
  }

  batchScheduleCard(batchScheduleId, date) {
    return this.get(`${this.route}/batch-card/${batchScheduleId}/${date}`, false);
  }

  attendanceCard(serviceId, date, startTime, endTime, enrollmentContractId) {
    return this.get(`${this.route}/attendance-card/${serviceId}/${date}/${startTime}/${endTime}/${!!enrollmentContractId ? enrollmentContractId : '-'}`, false);
  }
}

export default new CalendarProfessorService();
